import { IClassroomResource } from "../../classrooms";
import {
    type IEducationalScenarioSlotResource,
    type IEducationalScenarioTrainingAction,
} from "../../educational-scenario-slots";
import { createApiQueryHook, IApiQueryFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { serialize } from "../../utils/url";

export enum EducationalScenarioSlotScale {
    MONTH = "month",
    WEEK = "week",
    DAY = "day",
}

/** The endpoint answers with the whole scenario at once: it takes no pagination. */
export type IEducationalScenarioQueryParameters = {
    classroom?: RelationalValue<IClassroomResource>;
    filters?: {
        scale?: EducationalScenarioSlotScale;
    };
};

export type IEducationalScenarioResult = {
    slots: IEducationalScenarioSlotResource[];
    trainingActions: IEducationalScenarioTrainingAction[];
};

const mapFilters = (filters: IEducationalScenarioQueryParameters["filters"]) => {
    const { scale } = filters ?? {};

    return {
        scale,
    };
};

export const educationalScenarioQuery: IApiQueryFunction<IEducationalScenarioQueryParameters> = ({
    classroom,
    filters,
}) => {
    return {
        method: "GET",
        url: `/educational_scenario/classrooms/${mapRelationalValue(classroom)}${serialize(mapFilters(filters), true)}`,
    };
};

export const useEducationalScenarioQuery = createApiQueryHook<
    IEducationalScenarioQueryParameters,
    IEducationalScenarioResult
>(educationalScenarioQuery);
